// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputbox-gst {
    border: white;
    background-color: transparent;
}
.inputbox-gst:focus{
    /* border: white; */
    outline: none;
}
.wrapper {
    text-transform: uppercase;

    color: #555;
    cursor: help;
    font-size: 15px;
    /* padding: 15px 20px; */
    position: relative;
    text-align: center;
    -webkit-transform: translateZ(0);
    /* webkit flicker fix */
    -webkit-font-smoothing: antialiased;
    /* webkit text rendering fix */
}

.wrapper .tooltip {
        text-align: center;
    border-radius: 8px;
    background: black;
    bottom: 100%;
    color: #fff;
    display: block;
    left: 0px;
    margin-bottom: 15px;
    opacity: 0;
    padding: 10px;
    pointer-events: none;
    position: absolute;
    width: 100%;
    transform: translateY(10px);
    transition: all .25s ease-out;
    -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
}

/* This bridges the gap so you can mouse into the tooltip without it disappearing */
.wrapper .tooltip:before {
    bottom: -20px;
    content: " ";
    display: block;
    height: 20px;
    left: 0;
    position: absolute;
    width: 100%;
}

/* CSS Triangles - see Trevor's post */
.wrapper .tooltip:after {
    border-left: solid transparent 10px;
    border-right: solid transparent 10px;
    border-top: solid black 10px;
    bottom: -10px;
    content: " ";
    height: 0;
    left: 50%;
    margin-left: -13px;
    position: absolute;
    width: 0;
}

.wrapper:hover .tooltip {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0px);
}

/* IE can just show/hide with no transition */
.lte8 .wrapper .tooltip {
    display: none;
}

.lte8 .wrapper:hover .tooltip {
    display: block;
}

.loader {
    height: 4px;
    width: 130px;
    --c: no-repeat linear-gradient(black 0 0);
    background: var(--c), var(--c), #f6f7f8;
    background-size: 60% 100%;
    animation: l16 3s infinite;
}

@keyframes l16 {
    0% {
        background-position: -150% 0, -150% 0
    }

    66% {
        background-position: 250% 0, -150% 0
    }

    100% {
        background-position: 250% 0, 250% 0
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Basket/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,yBAAyB;;IAEzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB;IACvB,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;QACQ,kBAAkB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IAKX,2BAA2B;IAK3B,6BAA6B;IAG7B,+CAA+C;IAC/C,8CAA8C;IAC9C,2CAA2C;AAC/C;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;AACf;;AAEA,sCAAsC;AACtC;IACI,mCAAmC;IACnC,oCAAoC;IACpC,4BAA4B;IAC5B,aAAa;IACb,YAAY;IACZ,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,oBAAoB;IAKpB,0BAA0B;AAC9B;;AAEA,6CAA6C;AAC7C;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,uCAAuC;IACvC,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ","sourcesContent":[".inputbox-gst {\n    border: white;\n    background-color: transparent;\n}\n.inputbox-gst:focus{\n    /* border: white; */\n    outline: none;\n}\n.wrapper {\n    text-transform: uppercase;\n\n    color: #555;\n    cursor: help;\n    font-size: 15px;\n    /* padding: 15px 20px; */\n    position: relative;\n    text-align: center;\n    -webkit-transform: translateZ(0);\n    /* webkit flicker fix */\n    -webkit-font-smoothing: antialiased;\n    /* webkit text rendering fix */\n}\n\n.wrapper .tooltip {\n        text-align: center;\n    border-radius: 8px;\n    background: black;\n    bottom: 100%;\n    color: #fff;\n    display: block;\n    left: 0px;\n    margin-bottom: 15px;\n    opacity: 0;\n    padding: 10px;\n    pointer-events: none;\n    position: absolute;\n    width: 100%;\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    -webkit-transition: all .25s ease-out;\n    -moz-transition: all .25s ease-out;\n    -ms-transition: all .25s ease-out;\n    -o-transition: all .25s ease-out;\n    transition: all .25s ease-out;\n    -webkit-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\n    -moz-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\n    -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\n    -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\n    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\n}\n\n/* This bridges the gap so you can mouse into the tooltip without it disappearing */\n.wrapper .tooltip:before {\n    bottom: -20px;\n    content: \" \";\n    display: block;\n    height: 20px;\n    left: 0;\n    position: absolute;\n    width: 100%;\n}\n\n/* CSS Triangles - see Trevor's post */\n.wrapper .tooltip:after {\n    border-left: solid transparent 10px;\n    border-right: solid transparent 10px;\n    border-top: solid black 10px;\n    bottom: -10px;\n    content: \" \";\n    height: 0;\n    left: 50%;\n    margin-left: -13px;\n    position: absolute;\n    width: 0;\n}\n\n.wrapper:hover .tooltip {\n    opacity: 1;\n    pointer-events: auto;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n}\n\n/* IE can just show/hide with no transition */\n.lte8 .wrapper .tooltip {\n    display: none;\n}\n\n.lte8 .wrapper:hover .tooltip {\n    display: block;\n}\n\n.loader {\n    height: 4px;\n    width: 130px;\n    --c: no-repeat linear-gradient(black 0 0);\n    background: var(--c), var(--c), #f6f7f8;\n    background-size: 60% 100%;\n    animation: l16 3s infinite;\n}\n\n@keyframes l16 {\n    0% {\n        background-position: -150% 0, -150% 0\n    }\n\n    66% {\n        background-position: 250% 0, -150% 0\n    }\n\n    100% {\n        background-position: 250% 0, 250% 0\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
